export const USER_DETAILS = "userDetails";
export const COMMON_SSO_ACCESS_TOKEN = "access_token";
export const COMMON_SSO_MOBILE = "mobileNumber";
export const CHECK_COOKIE = "checkCookie";
export const COOKIE_SALT = "cookieSalt";
export const AUTH_TYPE = "authType";
export const PERPETUAL_TOKEN = "p_token";
export const MOBILE = "mobile";
export const CUST_ID = "custId";
export const USER_IDENTIFIER = "_si";
export const BFDL_FEDERATED_PRODUCT_CODE = "BFDL";
export const BAJAJMALL_FEDERATED_PRODUCT_CODE = "BAJAJMALL";
export const INSURANCE_FEDERATED_PRODUCT_CODE = "INS";
export const URL_MODULE_MAPPING = "urlModuleMapping";
export const URL_MAPPING_SET = "urlMappingSet";
export const EXPIRED_TIME = "_expiredTime";
export const TOKEN_EXPIRY = "tokenExpiry";
export const REFRESH_KEY = "refresh";
export const APP_SRC = "src";
export const APP_3in1 = "3in1";
export const APP_URL_INDENTIFIER = "/app-v";
export const WEB_VIEW_MODE = "webViewMode";
export const WEB_VIEW_MODE_ON = "on";
export const TOKEN_SRC = "tokenSrc";
export const KEY = "key";
export const TOKEN = "token";
export const SOURCE = "source";
export const AIRTEL = "Airtel";
export const REQ_DATA = "reqData";
// this can be removed in the future, when react project is removed
export const LSFLAG = "_lsFlag";
export const APP_M1 = "M1";
export const M1_PARTNER_BUSINESS = "partnerBusiness";
export const M1_OFFER = "M1_OFFER";
export const M1_NO_OFFER = "M1_NO_OFFER";
export const NOTIFICATION_ENABLED = "notificationEnabled";
export const SSO_CHANNEL_ID = {
  UAT: "1",
  PROD: "59",
};
